<template>
    <div class="editable-item"
         :class="{'editing-now': editing}">
        <slot name="value">
            <span v-if="autoHasValue && !displayValueIsHtml"
                  class="hide-on-edit"
                  :class="editable ? 'editable': ''"
                  @click.prevent="edit"
                  class="value">{{ autoDisplayValue }}</span>
            <span v-if="autoHasValue && displayValueIsHtml"
                  class="hide-on-edit"
                  :class="editable ? 'editable': ''"
                  @click.prevent="edit"
                  class="value">{{{ autoDisplayValue }}}</span>
        </slot>

        <slot name="placeholder">
            <span v-if="!autoHasValue"
                  class="hide-on-edit placeholder"
                  :class="editable ? 'editable': ''"
                  @click.prevent="edit">{{ placeholder }}</span>
        </slot>

        <div v-if="editing"
             class="editing f -a-center -a-gutter-small">
            <slot name="editor">
                <em>editing not implemented...</em>
            </slot>

            <div class="btn-group">
                <button class="btn btn-success btn-sm"
                        @click="validate"
                        :class="valid ? '' : 'disabled'">
                    <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button class="btn btn-danger btn-sm"
                        @click="cancel">
                    <i class="glyphicon glyphicon-remove"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped
       lang="less">
    @import './variables';

    span.editable {
        cursor: pointer;

        &:hover {
            background-color: @color-hover;
            border-radius: 5px;
        }
    }

    .editable-item {
        display: inline-block;
        position: relative;
    }

    .editing {
        position: absolute;
        align-items: center;

        top: 50%;
        transform: translateY(-50%);
        left: 0;
        z-index: 1;
        background-color: white;

        .btn-group {
            margin-left: 5px;
            flex-shrink: 0;
        }
    }

    .hide-on-edit {
        .editing-now & {
            opacity: 0;
        }
    }

    .placeholder {
        font-style: italic;
        color: lighten(@text-color, 20%);
    }
</style>

<script type="text/ecmascript-6">
    export default {
        props: {
            value: {
                twoWay: true
            },
            placeholder: {
                'default': 'Éditer...'
            },
            valid: {
                'default': true
            },
            displayValue: {
                'default': undefined
            },
            displayValueIsHtml: {
                'default': false
            },
            hasValue: {
                'default': undefined
            }
        },
        computed: {
            autoDisplayValue() {
                if (this.displayValue) {
                    return this.displayValue;
                }

                return this.value;
            },
            autoHasValue() {
                if (this.hasValue !== undefined) {
                    return this.hasValue;
                }

                return !!this.value;
            }
        },
        data() {
            return {
                editing: false,
                editable: true,
                escapeListener: undefined
            };
        },
        ready() {
            this.escapeListener = (evt) => {
                if (evt.keyCode === 27 && this.editing) {
                    this.cancel();
                }
            };

            document.addEventListener('keydown', this.escapeListener);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.escapeListener);
        },
        methods: {
            edit() {
                if (!this.editable) {
                    return;
                }

                this.$root.$broadcast('editable:startEdition');
                this.editing = true;

                const {width} = this.$el.getBoundingClientRect();
                this.$dispatch('editable:childStartEdition', {width});
            },
            validate() {
                if (!this.valid) {
                    return;
                }

                this.editing = false;
                this.$dispatch('editable:childValidateEdition');
                this.$root.$broadcast('editable:stopEdition');
            },
            cancel() {
                this.editing = false;
                this.$root.$broadcast('editable:stopEdition');
            }
        },
        events: {
            'editable:startEdition': function () {
                this.editable = false;
            },
            'editable:stopEdition': function () {
                this.editable = true;
            },
            'editable:validate': function () {
                this.validate();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Editable.vue?23e8a8b8